 (function(){
      function breakToolTip(){
     $('.swatch-element .tooltip').each(function(e,i,v){
       var text = $(this).text();
       text = text.split('/');
       if(text.length > 1) {
         text = text.join(" / ");
          $(this).text(text);
       } else {
         $(this).text(text[0]);
       }
     });
     
//      $('.template-collection .swatch-element-wrapper').each(function(i,e,v){
//        if($(e).find('.swatch-element').length <= 1) {
//          $(e).addClass('hide');
//        }
//      });
   }
   
   breakToolTip();

   function variantAvailable(){
	 $('.unavailable input').prop('disabled', true);
   }
   
   variantAvailable();
   
// for collections page   
   function attachSwatches(){
   	   $(".template-collection .product-swatches label").mouseenter(function(e){
        var $this = $(this);
       // console.log($this);
        var imgSrc = $this.prev().attr("variant-src");
        var url = $this.prev().attr("variant-url");
         var $mainLink = $this.closest(".product-list-item").find("figure").find("a");
         var $mainImg = $this.closest(".product-list-item").find("figure").find("img");
         $mainImg.attr("src", imgSrc);
        $mainLink.attr("href", url);
      });

   		$(".template-collection .product-swatches label").click(function(e){
        var $this = $(this);
        var url = $this.prev().attr("variant-url");
        window.location = url;
      });
   
   }
   
   attachSwatches();      
// end of function
   
    // load in js after ajax call
   var height = $(document).height(); // returns height of HTML document
   $(document).on("scroll", function(){
    // console.log("scrolling");
     if(height < $(document).height()){
       height = $(document).height(); 
      // console.log("load script");
       // get script 
       attachSwatches();
     }
   });
   
})();


// HC - 03 Aug '21 - mobile checkout
$(function(){
  $(".hc-mob-checkout").click(function(ev){
    ev.preventDefault();
    console.log("asdfasdfsdf xxx");
    $(".cart-checkout input[type=submit]").trigger("click");
  });
});